import React from 'react';

const SummaryStep = ({ formData }) => {
  const profissoesLabels = {
    pedreiro: 'Pedreiro',
    pintor: 'Pintor',
    encanador: 'Encanador',
    eletricista: 'Eletricista',
    azulejista: 'Azulejista',
    gesseiro: 'Gesseiro'
  };

  return (
    <div>
      <h2 className="text-3xl font-semibold text-gray-900 mb-6">
        Resumo do Cadastro
      </h2>
      
      <div className="space-y-6">
        {/* Dados Pessoais */}
        <div>
          <h3 className="text-lg font-medium text-gray-900 mb-4 pb-2 border-b border-gray-200">
            Dados Pessoais
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <span className="text-base font-medium text-gray-500">Nome:</span>
              <p className="text-gray-900">{formData.nome || 'Não informado'}</p>
            </div>
            <div>
              <span className="text-base font-medium text-gray-500">Telefone:</span>
              <p className="text-gray-900">{formData.telefone || 'Não informado'}</p>
            </div>
            <div>
              <span className="text-base font-medium text-gray-500">E-mail:</span>
              <p className="text-gray-900">{formData.email || 'Não informado'}</p>
            </div>
            <div>
              <span className="text-base font-medium text-gray-500">Endereço:</span>
              <p className="text-gray-900">
                {[formData.bairro, formData.cidade, formData.estado]
                  .filter(Boolean)
                  .join(', ') || 'Não informado'}
              </p>
            </div>
          </div>
        </div>

        {/* Informações Profissionais */}
        <div>
          <h3 className="text-lg font-medium text-gray-900 mb-4 pb-2 border-b border-gray-200">
            Informações Profissionais
          </h3>
          <div className="space-y-4">
            <div>
              <span className="text-base font-medium text-gray-500">Profissões:</span>
              <div className="mt-1">
                {formData.profissoes.length > 0 ? (
                  <div className="flex flex-wrap gap-2">
                    {formData.profissoes.map(profissao => (
                      <span
                        key={profissao}
                        className="inline-flex items-center px-3 py-1 rounded-full text-base font-medium bg-primary-100 text-primary-800"
                      >
                        {profissoesLabels[profissao]}
                      </span>
                    ))}
                  </div>
                ) : (
                  <p className="text-gray-900">Nenhuma profissão selecionada</p>
                )}
              </div>
            </div>

            <div>
              <span className="text-base font-medium text-gray-500">Habilidades Específicas:</span>
              <p className="text-gray-900 mt-1 whitespace-pre-wrap">{formData.habilidades || 'Não informado'}</p>
            </div>

            {formData.pretensao && (
              <div>
                <span className="text-base font-medium text-gray-500">Pretensão de Emprego:</span>
                <p className="text-gray-900 mt-1">
                  {formData.pretensao === 'autonomo' && 'Autônomo (trabalhar por conta própria)'}
                  {formData.pretensao === 'empregado' && 'Empregado (com carteira assinada)'}
                  {formData.pretensao === 'ambos' && 'Ambos (autônomo e empregado)'}
                </p>
              </div>
            )}

            <div>
              <span className="text-base font-medium text-gray-500">Experiência Profissional:</span>
              <p className="text-gray-900 mt-1 whitespace-pre-wrap">
                {formData.experiencia || 'Não informado'}
              </p>
            </div>
          </div>
        </div>

        {/* Mensagem de confirmação */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-blue-400" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-3">
              <h3 className="text-base font-medium text-blue-800">
                Quase Pronto!
              </h3>
              <div className="mt-2 text-base text-blue-700">
                <p>
                  <strong>Revise as informações acima</strong> e clique no botão <strong>"Concluir Cadastro"</strong> abaixo para finalizar seu registro.
                </p>
                <p className="mt-1">
                  Após clicar, seus dados serão salvos e você receberá uma confirmação.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SummaryStep;
